module.exports = __webpack_public_path__ + "static/media/System_Boundary-ceilings.7cf05610.png";